import { mutatorAction } from "satcheljs";
import type FolderTreeLoadStateEnum from "../store/schema/FolderTreeLoadStateEnum";
import type { MailboxInfo } from "owa-client-types";
import getMailboxFolderTreeDataTable from "../selectors/getMailboxFolderTreeDataTable";

/**
 * MutatorAction that sets the loading state for folder tree.
 */
export const setLoadingStateForFolderTreeMutator: (folderTreeId: string, loadingState: FolderTreeLoadStateEnum, mailboxInfo: MailboxInfo) => void = mutatorAction("setLoadingStateForFolderTreeMutator", (folderTreeId: string, loadingState: FolderTreeLoadStateEnum, mailboxInfo: MailboxInfo): void => {
    const folderTree = getMailboxFolderTreeDataTable(mailboxInfo)?.get(folderTreeId);
    if (folderTree) {
        folderTree.loadingState = loadingState;
    }
});
